'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function ($rootScope, scopeUtils, $window) {
  // TODO : inject only if in dev mode ?

  $window.countWatchers = function (scopeOrEl) {
    var scope = scopeOrEl ? angular.isElement(scopeOrEl) ? $(scopeOrEl).scope() : scopeOrEl : $rootScope;
    return scopeUtils.countWatchers(scope);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/debug/injectGlobals.js
// module id = 2748
// module chunks = 13